<template>
  <div class="home-container">
    <div class="top-content w-full h-[75rem]">
      <div>
        <div v-animate class="content-text">
          <p v-html="$t('home.text1')"></p>
          <p v-html="$t('home.text57')"></p>
        </div>
        <div v-animate class="content-text2">
          {{ $t("home.text2") }}
        </div>
        <div class="content-btn">
          <div @click="handleDownload" v-animate class="btn">{{ $t("home.text3") }}</div>
          <a :href="downloadUrl" :download="downloadUrl">
            <div v-animate class="btn btn1">{{ $t("home.text4") }}</div>
          </a>
        </div>
        <div v-animate class="content-info">
          <img src="@/assets/images/influenbase-icon-1.png" alt="" />
          <div class="info-text">
            <div v-html="$t('home.text5')"></div>
          </div>
        </div>
      </div>
      <div v-animate class="content-case">
        <img
          src="@/assets/images/influenbase-top-bg-case.png"
          v-if="locale === 'zh'"
          alt=""
        />
        <img src="@/assets/images/influenbase-top-bg-case1.webp" v-else alt="" />
      </div>
    </div>

    <section class="section1">
      <h1 v-animate class="page-text1 text-center">{{ $t("home.text6") }}</h1>
      <div v-animate class="content-text2 text-center mt-[20px]">
        {{ $t("home.text7") }}
      </div>
      <div class="section1-regin">
        <div class="regin-left">
          <img src="@/assets/images/influenbase-regin.png" alt="" />
        </div>
        <div class="regin-right">
          <div class="content-text2">{{ $t("home.text8") }}</div>

          <ul v-animate>
            <li v-for="(item, index) in reginArr" :key="index">{{ item }}</li>
          </ul>
        </div>
      </div>

      <div class="section1-tool">
        <div v-animate v-for="(item, index) in tools">
          <div class="tool-icon"><img :src="item.icon" alt="" /></div>
          <div :class="item.class" class="tool-title">
            {{ item.title }}
          </div>
          <div :class="item.descClass" class="tool-desc">{{ item.desc }}</div>
          <div class="tool-img"><img :src="item.img" alt="" /></div>
        </div>
      </div>
    </section>

    <section class="section2">
      <h2 v-animate class="page-text1 text-center">{{ $t("home.text54") }}</h2>
      <ul>
        <li v-animate v-for="item in effectData" :class="item.class">
          <img
            class="w-[24px] h-[24px] mr-[6px]"
            v-if="item.icon"
            :src="item.icon"
            alt=""
          />
          <p v-html="item.text"></p>
        </li>
      </ul>
    </section>

    <section class="section3">
      <h2 v-animate :class="{ 'w-[300px]': locale === 'zh' }" class="page-text1">
        {{ $t("home.text40") }}
      </h2>
      <div class="active-tool">
        <el-icon
          @click="handleStep('prev')"
          :class="currentStep !== 0 ? 'active' : ''"
          size="28"
        >
          <ArrowLeftBold />
        </el-icon>
        <el-icon
          @click="handleStep('next')"
          :class="currentStep !== stepNum - 1 ? 'active' : ''"
          size="28"
        >
          <ArrowRightBold />
        </el-icon>
      </div>

      <div class="transition-box" ref="carouselBox">
        <div
          :style="{
            transform: `translateX(-${translateX}px)`,
          }"
          class="transition-content"
          ref="carouselContent"
        >
          <div
            v-animate
            class="transition-item"
            v-for="(item, index) in carouselData"
            :key="index"
          >
            <p>
              <img
                v-show="index % 2 == 0"
                src="@/assets/images/influenbase-carousel-icon1.png"
                alt=""
              />
              <img
                v-show="index % 2 !== 0"
                src="@/assets/images/influenbase-carousel-icon2.png"
                alt=""
              />
            </p>
            {{ item }}
          </div>
        </div>
      </div>

      <div class="transition-dot">
        <span
          class="dot"
          v-for="item in stepNum"
          :key="item"
          :class="item === currentStep + 1 ? 'active' : ''"
        ></span>
      </div>
    </section>

    <section class="section4">
      <h2 v-animate class="page-text1 text-center">{{ $t("home.text47") }}</h2>
      <div v-animate :class="{ hover: locale === 'zh' }" class="brand-box">
        <img
          class="img1"
          src="@/assets/images/influenbase-brand-1.png"
          alt=""
          srcset=""
          @click="handleGotoBrand('https://psylos1.com/')"
        />
        <img
          class="img8"
          src="@/assets/images/influenbase-brand-8.png"
          alt=""
          srcset=""
          @click="handleGotoBrand('https://www.waterh.com/')"
        />
        <img
          class="img5"
          src="@/assets/images/influenbase-brand-5.png"
          alt=""
          srcset=""
          @click="handleGotoBrand('https://www.lordandberry.com/')"
        />
        <img
          class="img9"
          src="@/assets/images/influenbase-brand-9.png"
          alt=""
          srcset=""
          @click="handleGotoBrand('https://reviveskincare.com/')"
        />
        <img
          class="img7"
          src="@/assets/images/influenbase-brand-7.png"
          alt=""
          srcset=""
          @click="handleGotoBrand('https://siawag.com/')"
        />
        <img
          class="img2"
          src="@/assets/images/influenbase-brand-2.png"
          alt=""
          srcset=""
          @click="handleGotoBrand('https://www.tiktok.com/')"
        />
        <img
          class="img4"
          src="@/assets/images/influenbase-brand-4.png"
          v-if="locale === 'zh'"
          alt=""
          srcset=""
          @click="handleGotoBrand('https://www.sellersprite.com/')"
        />
        <img
          class="img4"
          src="@/assets/images/influenbase-brand-4-1.webp"
          v-else
          alt=""
          srcset=""
        />
        <img
          class="img3"
          src="@/assets/images/influenbase-brand-3.png"
          v-if="locale === 'zh'"
          alt=""
          srcset=""
          @click="handleGotoBrand('https://echotik.live')"
        />
        <img
          class="img3"
          src="@/assets/images/influenbase-brand-3-1.webp"
          v-else
          alt=""
          srcset=""
        />
        <img
          class="img6"
          src="@/assets/images/influenbase-brand-6.png"
          v-if="locale === 'zh'"
          alt=""
          srcset=""
          @click="handleGotoBrand('https://www.tt123.com/')"
        />
        <img
          class="img6"
          src="@/assets/images/influenbase-brand-6-1.webp"
          v-else
          alt=""
          srcset=""
        />
        <img
          class="img10"
          src="@/assets/images/influenbase-brand-10.png"
          alt=""
          srcset=""
          @click="handleGotoBrand('https://www.shopline.com/')"
        />
      </div>
    </section>
  </div>

  <img
    class="w-[100px] h-[131px] fixed right-[40px] top-[48vh] cursor-pointer"
    :src="toolImg"
    alt=""
    @click="handleOpen"
  />

  <contactDialog v-model="showDialog"></contactDialog>
</template>

<script setup lang="ts">
import contactDialog from "@/components/Dialog/contactDialog.vue";
import { usePageScript } from "@/hooks/usePageScript";
import { onMounted, ref, computed } from "vue";
import { ArrowLeftBold, ArrowRightBold } from "@element-plus/icons-vue";
import { getConfig } from "@/utils";

const downloadUrl = computed(() => {
  return getConfig("website_offline_download_url");
});

const {
  reginObj,
  carouselData,
  tools,
  effectData,
  reginArr,
  showDialog,
  handleDownload,
  handleOpen,
  toolImg,
  locale,
} = usePageScript();

let stepNum = ref(2);
const currentStep = ref(0);
const translateX = ref(0);

function handleStep(type: "prev" | "next") {
  const stepActions = {
    prev: () => {
      if (currentStep.value === 0) return;
      currentStep.value -= 1;
      translateX.value -= carouselBox.value?.clientWidth || 0;
    },
    next: () => {
      if (currentStep.value === stepNum.value - 1) return;
      currentStep.value += 1;
      translateX.value += carouselBox.value?.clientWidth || 0;
    },
  };

  stepActions[type]();
}
const carouselBox = ref<HTMLDivElement>();
const carouselContent = ref<HTMLDivElement>();

function handleGotoBrand(url: string) {
  if (locale.value === "zh") {
    window.open(url);
  }
}
</script>

<style scoped lang="scss">
.page-text1 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 64px;
  color: #000000;
}

.top-content {
  background: url("../../assets/images/influenbase-top-bg.png") no-repeat center center;
  background-size: cover;
  border-radius: 0 0 60px 60px;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
  .content-text {
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    padding-top: 200px;
    font-size: 64px;
    margin: 0 auto;
    text-align: center;
    :deep(span) {
      color: #9038ff;
    }
    :deep(img) {
      height: 28px;
      vertical-align: top;
      padding-top: 10px;
    }
  }

  .content-text-en {
    font-size: 48px;
    width: 1100px;
  }

  .content-text2 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #565656;
    text-align: center;
    width: 560px;
    padding-top: 24px;
    margin: 0 auto;
  }

  .content-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 77px;

    .btn {
      width: 240px;
      height: 56px;
      border-radius: 100px 100px 100px 100px;
      border: 1px solid #9038ff;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: PingFang HK, PingFang HK;
      font-weight: 600;
      font-size: 18px;
      cursor: pointer;
      opacity: 0.7;
      transition: all 0.3s;
      background: url("@/assets/images/influenbase-btn-bg.png") no-repeat center center;
      background-size: 100% 100%;
      margin-right: 24px;
      color: #fff;
      &:hover {
        opacity: 1;
      }
    }
    .btn1 {
      background: transparent !important;
      color: #9038ff;
    }
  }

  .content-info {
    display: flex;
    align-items: center;
    width: 500px;
    margin: 25px auto 0 auto;
    img {
      width: 44px;
      height: 44px;
      margin-right: 12px;
    }

    .info-text {
      font-weight: 400;
      font-size: 14px;
      color: #535350;

      :deep(p:first-child) {
        font-family: Racing Sans One, Racing Sans One;
        font-weight: bold;
        font-size: 20px;
        color: #000000;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
    }
  }

  .content-case {
    font-size: 0;
    width: 912px;
    img {
      width: 100%;
    }
  }
}

.section1 {
  width: 1200px;
  margin: auto;
  margin-top: 200px;
  .content-text2 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 300;
    font-size: 20px;
    color: #858481;
  }

  .section1-regin {
    display: flex;
    align-items: center;
    margin-top: 80px;
    .regin-left {
      margin-right: 80px;
      width: 534px;
      img {
        width: 534px;
        height: 500px;
      }
    }
    .regin-right {
      flex: 1;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      justify-content: center;
      ul {
        margin-left: 20px;
        display: grid;
        gap: 0px 40px;
        grid-template-columns: repeat(3, 1fr);
        font-family: PingFang SC, PingFang SC;
        font-weight: 600;
        font-size: 24px;
        color: #000000;
        line-height: 44px;
        text-align: left;
        margin-top: 32px;

        li {
          position: relative;
          text-wrap: nowrap;
        }

        li::before {
          content: "";
          position: absolute;
          left: -20px;
          top: 50%;
          transform: translateY(-50%);
          width: 8px;
          height: 8px;
          background: #000;
          border-radius: 50%;
        }
      }
    }
  }
  .section1-tool {
    margin-top: 182px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 32px;
    > div {
      background: #ffffff;
      border-radius: 16px 16px 16px 16px;
      border: 1px solid #e1e1e1;
      padding: 24px;
      .tool-icon {
        img {
          width: 36px;
          height: 36px;
        }
      }
      .tool-title {
        margin-top: 40px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 32px;
        color: #000000;
      }

      .tool-desc {
        font-weight: 400;
        font-size: 20px;
        color: #858481;
        line-height: 28px;
        margin-top: 24px;
        min-height: 100px;
      }

      .tool-img {
        margin-top: 32px;
        img {
          width: 100%;
        }
      }
    }
  }
}

.section2 {
  width: calc(100vw - 104px);
  margin: auto;
  background: #f7f0fe;
  border-radius: 120px 120px 120px 120px;
  margin-top: 200px;
  padding: 102px 0;

  ul {
    display: grid;
    grid-template-columns: 160px 260px 280px 160px 200px;
    gap: 0 20px;
    width: calc(1200px);
    margin: auto;
    padding: 30px 30px 20px 30px;
    background: #ffffff;
    border-radius: 32px 32px 32px 32px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 24px;
    margin-top: 46px;
    li {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 20px 10px;
      p {
        text-align: center !important;
      }
    }

    .bg1 {
      background: rgba(185, 121, 255, 0.4);
    }
    .bg2 {
      background: #9038ff;
      color: #fff;
    }
    .border-top {
      border-radius: 32px 32px 0 0;
    }
    .border-bottom {
      border-radius: 0 0 32px 32px;
    }
  }
}

.section3 {
  margin-top: 150px !important;
  width: 1200px;
  margin: auto;

  .active-tool {
    margin-top: 32px;
    .el-icon {
      width: 52px;
      height: 52px;
      border: solid 2px #9038ff;
      border-radius: 50%;
      color: #9038ff;
      margin-right: 16px;
      cursor: pointer;
    }
    .active {
      color: #fff !important;
      background-color: #9038ff !important;
    }
  }
  .transition-box {
    margin-top: 90px;
    width: 100%;
    overflow: hidden;
    .transition-content {
      display: flex;
      align-items: flex-start;
      transition: all 0.3s;
      width: 200%;
      .transition-item {
        width: 400px;
        background: #f7f0fe;
        padding: 44px 52px;
        border-radius: 32px 32px 32px 32px;
        margin-right: 32px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 24px;
        color: #000000;
        p {
          img {
            width: 94px;
            height: 60px;
            margin-bottom: 32px;
          }
        }
      }
      .transition-item:nth-child(even) {
        background: #f8f8fa;
      }
    }
  }

  .transition-dot {
    display: flex;
    align-items: center;
    .dot {
      margin-right: 8px;
      width: 10px;
      height: 10px;
      border: solid 1px #9038ff;
      border-radius: 5px;
      transition: all 0.3s;
    }

    .active {
      width: 24px;
      background-color: #9038ff;
    }
  }
}

.section4 {
  width: 1200px;
  margin: auto;
  margin-top: 200px;
  padding-bottom: 187px;
  .brand-box {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 36px 50px;
    margin-top: 100px;
    place-items: center;
    img {
      height: 52px;
    }
  }
  .hover {
    cursor: pointer;
  }
}
.h-\[88px\] {
  height: 88px;
}
.h-\[100px\] {
  height: 140px;
}
.h-\[140px\] {
  height: 140px;
}
.h-\[160px\] {
  height: 160px;
}

.home-container {
  background: #fefcff;
}
</style>
